import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { MsalModule, MsalService, MsalGuard, MsalBroadcastService } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { authConfig } from './app/config/auth.config';

// MSAL Configuration - Dynamic URL resolution
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

// Get dynamic redirect URI based on current location
const getDynamicRedirectUri = () => {
    if (typeof window !== 'undefined' && window.location) {
        return window.location.origin;
    }
    return authConfig.msalConfig.auth.redirectUri; // fallback
};

export const msalConfig = {
    auth: {
        clientId: authConfig.msalConfig.auth.clientId,
        authority: authConfig.msalConfig.auth.authority,
        redirectUri: getDynamicRedirectUri(),
        postLogoutRedirectUri: getDynamicRedirectUri(),
        navigateToLoginRequestUrl: false // Prevent redirect loops
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: isIE
    },
    system: {
        allowNativeBroker: false,
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string) => {
                //console.log(message);
            },
            logLevel: LogLevel.Info,
            piiLoggingEnabled: false
        }
    }
};

export const loginRequest = {
    scopes: ['User.Read', 'profile', 'openid', 'email']
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        // MSAL providers
        importProvidersFrom(
            MsalModule.forRoot(
                new PublicClientApplication(msalConfig),
                {
                    interactionType: InteractionType.Redirect,
                    authRequest: loginRequest
                },
                {
                    interactionType: InteractionType.Redirect,
                    protectedResourceMap: new Map([
                        ['https://graph.microsoft.com/v1.0/me', ['User.Read']]
                    ])
                }
            )
        ),
        MsalService,
        MsalGuard,
        MsalBroadcastService
    ]
};
